import React from "react";
import Route from "./Routes";
import { ConfirmDialogProvider, ToastProvider } from "./design-system";
import { TourProvider } from "./tours/TourContext";

function App() {
  return (
    <ToastProvider>
      <ConfirmDialogProvider>
        <TourProvider>
          <Route />
        </TourProvider>
      </ConfirmDialogProvider>
    </ToastProvider>
  );
}

export default App;
